// extracted by mini-css-extract-plugin
export default {"labelWrapper":"Label-module_labelWrapper-RcVri","actionLeft":"Label-module_actionLeft-WW8AG","label":"Label-module_label-WmQAd"};